<template>
  <div :style="{ backgroundImage: `url(${info_banner.image.webp}), url(${info_banner.image.source})` }"
       class="info-block">
    <div class="container-lg">
      <div class="row">
        <div class="col-lg-7">
          <h3 class="info-block__title">
            {{ in18['page_informative_block'] }}
          </h3>
          <div class="info-block__text">
            {{ in18['page_informative_block_description'] }}
          </div>
          <a :href="info_link" :title="in18['page_show_more']" class="btn  btn--green  btn--md">
            {{ in18['page_show_more'] }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:  "Info",
  props: [
    'in18',
    'info_banner',
    'info_link',
  ],
}
</script>